'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSocial = require('react-social');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _AmazonStaffTakeActionShare = require('./AmazonStaffTakeActionShare.css');

var _AmazonStaffTakeActionShare2 = _interopRequireDefault(_AmazonStaffTakeActionShare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonStaffTakeActionShare = (_dec = (0, _reactCssModules2.default)(_AmazonStaffTakeActionShare2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonStaffTakeActionShare, _Component);

  function AmazonStaffTakeActionShare() {
    (0, _classCallCheck3.default)(this, AmazonStaffTakeActionShare);
    return (0, _possibleConstructorReturn3.default)(this, (AmazonStaffTakeActionShare.__proto__ || (0, _getPrototypeOf2.default)(AmazonStaffTakeActionShare)).apply(this, arguments));
  }

  (0, _createClass3.default)(AmazonStaffTakeActionShare, [{
    key: 'render',
    value: function render() {
      var planId = 'amazon-com';
      var planData = _config2.default.plansSource[planId];
      var description = 'See how ' + planData.plan_short_name + ' is rated on environmental and social sustainability issues.';
      var url = _config2.default.domain + _config2.default.routes.plans + '/' + planId;
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'take-action-share' },
        _react2.default.createElement(
          'div',
          { styleName: 'take-action-label' },
          _react2.default.createElement(
            'h2',
            null,
            'Email or share Amazon\'s results'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Share the scorecard for Amazon\'s 401(k) with your employer, coworkers, or social network.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _.Link,
              {
                to: _config2.default.routes.plans + '/amazon-com',
                title: 'Amazon retirement plan sustainability scorecard'
              },
              _react2.default.createElement(
                'span',
                { styleName: 'show-results-button' },
                'See Amazon\'s results',
                _react2.default.createElement(_.LinkIcon, null)
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'take-action-icons' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactSocial.EmailButton,
              {
                title: 'Share via email',
                message: description,
                url: url,
                element: 'a'
              },
              _react2.default.createElement(
                'p',
                null,
                'Email'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _.Link,
              {
                to: 'https://www.facebook.com/sharer/sharer.php?u=' + url,
                title: 'Share via Facebook'
              },
              _react2.default.createElement(
                'p',
                null,
                'Facebook'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-facebook-square' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactSocial.TwitterButton,
              {
                title: 'Share via Twitter',
                message: description,
                url: url,
                element: 'a'
              },
              _react2.default.createElement(
                'p',
                null,
                'Twitter'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-twitter-square' })
              )
            )
          )
        )
      );
    }
  }]);
  return AmazonStaffTakeActionShare;
}(_react.Component)) || _class);
exports.default = AmazonStaffTakeActionShare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonStaffTakeActionShare/AmazonStaffTakeActionShare.js
// module id = 1370
// module chunks = 0